import React, { FC, useState } from 'react';
import {
    CardHeader,
    DashboardCardBody,
    PostCard,
    CardLikeAndComment,
    CardCommentContent,
    CardCommentInput,
    Comments,
} from '../PostComponents';
import { PostProps } from './Post.types';
import { useLikes, useActions, useComments } from './../../hooks';
import { useFormik } from 'formik';
import { formDataCommentTypes, PostTypes } from './../../types';

const Post: FC<PostProps> = ({ url, index, post, user, hideActions, hideCommentsTag }) => {
    const [open, setOpen] = useState(false);
    const [currentPost, setCurrentPost] = useState<PostTypes>(post);
    // actions
    const { viewRef, openInNewTab } = useActions(url, `${url}/api/posts/${post?.id}/actions`);
    // likes
    const { onClickLike, likeLoading, handelLikeComment } = useLikes({
        url: `${url}/api/posts/${post?.id}/interactions`,
        setCurrentPost,
        likeCommentUrl: { p1: `${url}/api/comments`, p2: 'interactions' },
    });
    const [initialValues] = useState<formDataCommentTypes>({
        postId: currentPost?.id,
        content: '',
        editContent: '',
    });
    const { handleChange, values, handleSubmit, setFieldValue } = useFormik({
        enableReinitialize: true,
        initialValues,
        onSubmit: (values: formDataCommentTypes) => {
            if (!editId && values?.content !== '') {
                postComment(`${url}/api/comments`, values);
            }
            editId &&
                user &&
                values?.editContent !== '' &&
                values?.editContent !== undefined &&
                updateComment(`${url}/api/comments/${editId}`, {
                    content: values?.editContent,
                    userId: user?.id,
                });
        },
    });
    const {
        comments,
        postCommentLoading,
        actionsLoading,
        postComment,
        editComment,
        updateComment,
        deleteComment,
        editId,
        loading,
    } = useComments({
        url: `${url}/api/posts/${currentPost.id}/comments`,
        deleteCommentUrl: `${url}/api/comments`,
        user,
        open,
        setPost: setCurrentPost,
        setFieldValue,
    });

    return (
        <div ref={viewRef} aria-label={currentPost.id.toString()}>
            <PostCard key={index}>
                <CardHeader date={post?.createdAt} />
                <DashboardCardBody
                    video={currentPost?.video}
                    title={currentPost?.title}
                    source={currentPost?.image}
                    description={currentPost?.content}
                    imageLink={currentPost?.imageLink}
                    openInNewTab={openInNewTab}
                />
                {!hideActions && (
                    <>
                        <CardLikeAndComment
                            commentCount={currentPost.commentCount}
                            reactionCount={currentPost.reactionCount}
                            isLiked={currentPost.isLiked}
                            hideCommentsTag={hideCommentsTag}
                            onClickLike={() => !likeLoading && onClickLike()}
                            setOpen={setOpen}
                        />
                        {user && (
                            <CardCommentContent open={open}>
                                <CardCommentInput
                                    {...{
                                        user,
                                        handleSubmit,
                                        value: values?.content,
                                        handleChange,
                                        postCommentLoading,
                                    }}
                                />

                                <Comments
                                    {...{
                                        comments,
                                        editId,
                                        user,
                                        editvalue: values?.editContent,
                                        handleSubmit,
                                        handleChange,
                                        postCommentLoading,
                                        actionsLoading,
                                        editComment,
                                        deleteComment,
                                        loading,
                                        handelLikeComment,
                                        postId: currentPost?.id,
                                        url,
                                    }}
                                ></Comments>
                            </CardCommentContent>
                        )}
                    </>
                )}
            </PostCard>
        </div>
    );
};

export default Post;
